import { render, staticRenderFns } from "./AddRepairSetting.vue?vue&type=template&id=167c37a1"
import script from "./AddRepairSetting.vue?vue&type=script&lang=js"
export * from "./AddRepairSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports